* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;

  --font-family: var(--font-family-secondary);
  --outer-slider-background: var(--chart-100-pressed);
  --thumb-value-min-color: var(--grey-layout-chart-100);
  --thumb-value-max-color: var(--grey-layout-chart-100);
  --slider-background: linear-gradient(90deg, var(--red-alert-500-severe) 0%, var(--yellow-alert-050) 100%);
  --slider-value-color: var(--slider-background);
  --slider-second-value-max: 0px;
  --slider-second-value-min: 0px;
  --thumb-diameter: 20px;
  --thumb-diameter-moz: 12px;
}

.wrapper {
  display: flex;
  flex-direction: column;
  padding: calc(var(--spacer) * 3);
  z-index: 1;
}

.container {
  position: relative;
  width: 100%;
  height: 80px;
  direction: rtl;
}

.input-container {
  display: flex;
  flex-direction: row;

  label {
    font-size: var(--body-size-large);
    color: var(--body-text-arrows-400);
    padding-bottom: 6px;
  }
}

.slider-inputs {
  pointer-events: none;
}

:-moz-any(option) {
  &:before {
    content: attr(label);
    top: -5px;
    padding-top: var(--spacer);
    position: absolute;
  }
}

.datalist {
  display: flex;
  font-size: var(--body-size-large);
  width: 100%;
  justify-content: space-between;

  span {
    width: 3.3ex;
    display: flex;
    justify-content: center;
    align-items: end;
    height: 2ex;
    z-index: -1;
    color: var(--chart-300-icon-buttons);

    &:after {
      content: '';
      width: 1px;
      height: 8px;
      top: 19px;
      background-color: var(--chart-100-pressed);
      position: absolute;
    }
  }
}

input[type='range'] {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 100%;
  outline: none;
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  background-color: transparent;
  pointer-events: none;
}

.slider-track {
  width: 100%;
  height: 5px;
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  border-radius: 5px;
  background: var(--chart-100-pressed);
}

.range-track {
  width: calc(var(--slider-second-value-max) - var(--slider-second-value-min));
  right: var(--slider-second-value-min);
  background: var(--slider-value-color);
  height: 5px;
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  border-radius: 5px;
  z-index: 0;
  cursor: pointer;
}

.range-track-mask-right {
  height: 5px;
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  border-radius: 5px;
  background-color: var(--outer-slider-background);
  z-index: 0;
  width: var(--slider-second-value-min);
  cursor: pointer;
}

.range-track-mask-left {
  height: 5px;
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  right: auto;
  left: -1px;
  border-radius: 5px;
  background-color: var(--outer-slider-background);
  z-index: 0;
  width: calc(100% - var(--slider-second-value-max));
  cursor: pointer;
}

input[type='range']::-webkit-slider-runnable-track {
  -webkit-appearance: none;
  height: 5px;
}

input[type='range']::-moz-range-track {
  -moz-appearance: none;
  height: 5px;
}

input[type='range']::-ms-track {
  appearance: none;
  height: 5px;
}

input[type='range']::-webkit-slider-thumb {
  -webkit-appearance: none;
  height: var(--thumb-diameter);
  width: var(--thumb-diameter);
  cursor: ew-resize;
  margin-top: -8px;
  pointer-events: auto;
  transform: translateZ(0);
  border-radius: 50%;
  border: 4px solid var(--white-layout-301-level-0-elevation);
  filter: drop-shadow(0px 1px 3px var(--grey-layout-202-disabled-icons));
}

input[class='input-min']::-webkit-slider-thumb {
  background: var(--thumb-value-min-color, var(--grey-layout-chart-100));
}

input[class='input-max']::-webkit-slider-thumb {
  background: var(--thumb-value-max-color, var(--grey-layout-chart-100));
}

input[class='input-min']::-moz-range-thumb {
  background: var(--thumb-value-min-color, var(--grey-layout-chart-100));
}

input[class='input-max']::-moz-range-thumb {
  background: var(--thumb-value-max-color);
}

input[class='input-min']::-ms-thumb {
  background: var(--thumb-value-min-color, var(--grey-layout-chart-100));
}

input[class='input-max']::-ms-thumb {
  background: var(--thumb-value-max-color);
}

input[type='range']::-moz-range-thumb {
  -webkit-appearance: none;
  height: var(--thumb-diameter-moz);
  width: var(--thumb-diameter-moz);
  cursor: ew-resize;
  border-radius: 50%;
  -moz-outline-radius: 50%;
  pointer-events: auto;
  outline: 1px solid var(--chart-300-icon-buttons);
  border: 3px solid var(--white-layout-301-level-0-elevation);
}

input[type='range']::-ms-thumb {
  appearance: none;
  height: var(--thumb-diameter);
  width: var(--thumb-diameter);
  cursor: ew-resize;
  border-radius: 50%;
  pointer-events: auto;
  outline: 1px solid var(--chart-300-icon-buttons);
  border: 3px solid var(--white-layout-301-level-0-elevation);
}
